import { Component, Input, OnInit } from '@angular/core';
import { TabbedContainerComponent } from 'shared.components/tab-component/tabbed-container/tabbed-container.component';
import { Tab } from 'shared.models/tabbed-table.model';

@Component({
  selector: '[nc-content-tab]',
  templateUrl: './content-tab.component.html',
  standalone: false,
})

export class ContentTabComponent implements Tab, OnInit {
  tabSelected: boolean;

  @Input() tabTitle;
  // TODO: In the future we will need to make a component that handles custom tab titles,
  // currently the @Input() selectedCount; is a quick workaround
  // https://providersolution.visualstudio.com/PSG/User%20Experience/_backlogs/board/Stories
  @Input() selectedCount;
  @Input() tabId = 'tab';

  constructor(private tabsComponent: TabbedContainerComponent) { }

  ngOnInit(): void {
    this.tabsComponent.addTab(this);
  }

}
